import TlDictTag from "./src/index.vue";

TlDictTag.install = function (Vue) {
  Vue.component(TlDictTag.name, TlDictTag);
};

export default TlDictTag;
